import React from 'react';
import { useSelector } from 'react-redux';
import { EventResultCardProps } from '../types/bot.types';
import { Event } from '../../../modules/SportsAndEventsPage/sportsAndEventsInterface';
import EventCard from '../../EventCard/EventCard';
import { RootState } from '../../../store/store';
import '../../../modules/SwitchDatePicker/components/SearchResults/searchResultsEvents.less';

const EventResultCard: React.FC<EventResultCardProps> = ({
  event,
  onSelect,
}) => {
  const { agentInfo } = useSelector((data: RootState) => data.config);

  return (
    <div className="bot-result-card bot-result-card--event">
      <EventCard
        event={event as Event}
        compactView
        showAgentCommission={agentInfo?.agentMode}
        handleEventClick={() => onSelect()}
      />
    </div>
  );
};

export default EventResultCard;
